import { MoneyBox } from '@apply/components';
import { formatCurrencyOrUndefined } from '@apply/ui';
import { IBudgetFixFlip } from '@apply/api/src/api/ApplyApi';
import { ApplicationQuestionReviewItem } from '../../../../components/ApplicationQuestionReviewItem';
import { useBudgetFixFlipField } from '../../../../../queries/useBudgetFixFlipField';

interface FireplaceProps {
    required?: boolean;
    propertyGuid: string;
    isReview?: boolean;
}

export const Fireplace: React.FC<FireplaceProps> = ({ required = false, propertyGuid, isReview = false }) => {
    const [fireplace, set_fireplace] = useBudgetFixFlipField<number>(
        propertyGuid,
        (b) => (b.values?.['Interior']?.['Fireplace']?.[1] as number) ?? 0,
        (b, v) => ({ ...b, values: { ...b.values, 'Interior': { ...b.values?.['Interior'], 'Fireplace': [b.values?.['Interior']?.['Fireplace']?.[0] ?? '', v] as [string, number] } } })
    );
    const label = 'Fireplace';
    return (
        <>
            {isReview ? (
                <ApplicationQuestionReviewItem
                    label={label}
                    value={formatCurrencyOrUndefined(fireplace)}
                />
            ) : (
                <MoneyBox
                    id={'fireplace'}
                    allowNegative={false}
                    value={fireplace}
                    onChange={(value) => set_fireplace(value)}
                    required={required}
                    label={label}
                />
            )}
        </>
    );
};
